import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles } from '@material-ui/core/styles';

const UNHOVER_TIMEOUT = 100;
const ITEM_HEIGHT = 46;
const ITEMS_LIMIT = 15;

const styles = (theme) => ({
  button: {
    color: theme.palette.primary.contrastText,
    height: 48,
  },
  menuPaper: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: 0,
  },
  menuItem: {
    fontSize: 18,
    color: theme.palette.primary.contrastText,
    textTransform: 'uppercase',
  },
});

const folderHasActiveChildren = (children) => {
  let hasAtLeastOneActiveChild = false;
  children.forEach((child) => {
    if (child.isActive) hasAtLeastOneActiveChild = true;
  });
  return hasAtLeastOneActiveChild;
};

class Folder extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      hoverButton: false,
      hoverMenu: false,
      menuOpen: false,
    };

    this.folderRef = React.createRef();
  }

  handleHoverButton = (e) => {
    this.setState({ hoverButton: true, menuOpen: true });
  };

  handleHoverMenu = (_e) => {
    this.setState({ hoverMenu: true });
  };

  handleUnHoverButton = (e) => {
    this.setState({ hoverButton: false }, () => {
      setTimeout(() => {
        if (!this.state.hoverMenu && !this.state.hoverButton) {
          this.setState({ menuOpen: false });
        }
      }, UNHOVER_TIMEOUT);
    });
  };

  handleTouchStart = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }));
  };

  handleUnHoverMenu = (_e) => {
    this.setState({ hoverMenu: false }, () => {
      setTimeout(() => {
        if (!this.state.hoverMenu && !this.state.hoverButton) {
          this.setState({ menuOpen: false });
        }
      }, UNHOVER_TIMEOUT);
    });
  };

  renderChildren() {
    const { classes, folder } = this.props;
    return (
      <Popper
        open={this.state.menuOpen}
        anchorEl={this.folderRef.current}
        transition
        disablePortal
        style={{ zIndex: 10 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            timeout={90}
            style={{
              transformOrigin:
                placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper
              onMouseEnter={this.handleHoverMenu}
              onMouseLeave={this.handleUnHoverMenu}
              style={{
                maxHeight: 8 + ITEM_HEIGHT * ITEMS_LIMIT + ITEM_HEIGHT / 2,
                // maxHeight: "100vh",
                overflowY: 'scroll',
              }}
              className={classes.menuPaper}
            >
              <MenuList>
                {folder.children.map(
                  (page) =>
                    page.isActive && (
                      <MenuItem
                        component="a"
                        key={page.id}
                        href={page.link}
                        target={page.open_in_new_tab ? '_blank' : '_self'}
                        rel={
                          page.open_in_new_tab ? 'noopener noreferrer' : null
                        }
                        className={classes.menuItem}
                      >
                        {page.title}
                      </MenuItem>
                    )
                )}
              </MenuList>
            </Paper>
          </Grow>
        )}
      </Popper>
    );
  }

  render() {
    const { folder, classes, isEditingOrganization } = this.props;
    const { title } = folder;

    return (
      folder.isActive &&
      (isEditingOrganization || folderHasActiveChildren(folder.children)) && (
        <ClickAwayListener
          onClickAway={() => {
            this.setState({
              hoverButton: false,
              hoverMenu: false,
              menuOpen: false,
            });
          }}
        >
          <React.Fragment>
            <Button
              onMouseEnter={this.handleHoverButton}
              onMouseLeave={this.handleUnHoverButton}
              onTouchStart={this.handleTouchStart}
              buttonRef={this.folderRef}
              className={classes.button}
            >
              {`${title} ▼`}
            </Button>
            {this.renderChildren()}
          </React.Fragment>
        </ClickAwayListener>
      )
    );
  }
}

Folder.propTypes = {
  isEditingOrganization: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  folder: PropTypes.shape({
    id: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.array.isRequired,
  }),
};
Folder.defaultProps = {};

export default withStyles(styles)(Folder);
